var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.iconClass,attrs:{"src":_vm.iconPath,"width":"20px","height":"22px","alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }